export const setRootClassName = (classes: string[], set?: boolean) => {
  // prettier-ignore
  // eslint-disable-next-line no-nested-ternary
  const operation = set == null
    ? 'toggle'
    : set
      ? 'add'
      : 'remove';

  for (const cls of classes) {
    window.document.documentElement.classList[operation](cls);
  }
};
